import React, { useContext } from 'react';
import { Pills, PillOption } from 'components/pills/Pills';
import { Option, FilterGroup } from './types';
import { WalletSortAndFilterContext } from './context';
import { allCards } from './util';

export const SelectionPills = () => {
    const { selectedBrands, setSelectedBrands, activeCardTypeFilter, setActiveCardTypeFilter } =
        useContext(WalletSortAndFilterContext);
    const options: PillOption[] = [...Array.from(activeCardTypeFilter), ...selectedBrands];
    const pillsExist = options.length > 0;

    const onRemove = (pillOption: PillOption) => {
        const option = pillOption as Option;

        if (option.group === FilterGroup.brand) {
            setSelectedBrands((selections: Option[]) => {
                return selections.filter((selection: Option) => selection.value !== option.value);
            });
        } else {
            const updatedCardTypeFilter = new Set<Option>(activeCardTypeFilter);

            if (updatedCardTypeFilter.size === 1) {
                // CASE: we only have 1 filter active, we should _remove it_ and add _allCards_
                // as a default
                updatedCardTypeFilter.delete(option);
                updatedCardTypeFilter.add(allCards);
            } else if (option === allCards) {
                // CASE: allCards filter is trying to be checked off
                // we should not allow the user to do that
            } else {
                // BASE CASE: we just want to delete an option
                updatedCardTypeFilter.delete(option);
            }
            setActiveCardTypeFilter(updatedCardTypeFilter);
        }
    };

    const clearAll = () => {
        setSelectedBrands([]);
        setActiveCardTypeFilter(new Set<Option>([allCards]));
    };

    return (
        <div className="my-6 sm:my-6 sm:mx-4 flex items-center">
            {pillsExist && (
                <button
                    className="text-xs flex-none underline text-brand font-semibold mr-4"
                    onClick={clearAll}
                >
                    Clear All
                </button>
            )}
            <Pills options={options} onRemove={onRemove} />
        </div>
    );
};
